import React, { useEffect, useState } from "react";

import CurrentStock from "./Stats/CurrentStock";
import StockValue from "./Stats/StockValue";
import StockOut from "./Stats/StockOut";
import StockIn from "./Stats/StockIn";
import ProductSold from "./Stats/ProductSold";
import ToBePacked from "./Stats/ToBePacked";
import ToBeShipped from "./Stats/ToBeShipped";
import ToBeDelivered from "./Stats/ToBeDelivered";

import VendorsBarChart from "./Charts/VendorsBarChart";
import AverageCostChart from "./Charts/AverageCostChart";
import QualityPurchaseChart from "./Charts/QualityPurchaseChart";
import SellingPlansPieChart from "./Charts/SellingPlansPieChart";
import PurchaseAnalysisChart from "./Charts/PurchaseAnalysisChart";

import NewVendors from "./Vendors/NewVendors";
import SalesOrders from "./Sales/SalesOrders";

import Service from "../../Services/Service";
import DashboardService from "../../Services/Dashboard_service";

// ✅ Added from 2nd file
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar } from "@mui/material";
import "../../styles/login.css";

export default function Dashboard() {
  const [time, setTime] = useState(new Date());
  const [menus, setMenus] = useState([]);
  const [dashboardMenus, setDashboardMenus] = useState([]);

  // ✅ Added from 2nd file
  const location = useLocation();
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loginUsername, setLoginUsername] = useState("");

  // ✅ Added from 2nd file — login success snackbar trigger
  useEffect(() => {
    const shouldShow =
      Boolean(location.state?.showLoginSuccess) ||
      sessionStorage.getItem("showLoginSuccess") === "true";

    if (shouldShow) {
      const user =
        location.state?.username ||
        sessionStorage.getItem("loginSuccessUser") ||
        sessionStorage.getItem("empname") ||
        sessionStorage.getItem("userEmail") ||
        "User";

      setLoginUsername(user);
      setOpenSnackbar(true);

      sessionStorage.removeItem("showLoginSuccess");
      sessionStorage.removeItem("loginSuccessUser");
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.href);
      }
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/RoleMapping");

    Service.loadSideBarMnus(sessionStorage.getItem("empname"), "Get")
      .then((res) => {
        setMenus(res.data.table || []);
      })
      .catch((err) => { });
  }, []);

  useEffect(() => {
    DashboardService.setApiUrl(
      sessionStorage.getItem("APIUrl") + "/api/DashBoard"
    );

    DashboardService.getVisibleMenus(sessionStorage.getItem("GroupId"))
      .then((res) => {
        setDashboardMenus(res.data || []);
      })
      .catch((err) => { });
  }, []);

  return (
    <div
      className="container-fluid p-4"
      style={{ background: "#f5f7fb", minHeight: "100vh" }}
    >
      {/* HEADER */}
      <div className="d-flex justify-content-between mb-4">
        <div>
          <h4 className="fw-bold">
            Welcome back, {sessionStorage.getItem("empname")}
          </h4>
        </div>

        <div className="text-end">
          <h6 className="fw-bold text-primary">{time.toLocaleDateString()}</h6>
          <small>{time.toLocaleTimeString()}</small>
        </div>
      </div>

      {/* STATS */}
      <div className="row g-3">
        {dashboardMenus.some((m) => m.menuText === "Current Stock") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <CurrentStock />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "Stock Value") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <StockValue />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "Stock Out") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <StockOut />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "Stock In") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <StockIn />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "Product Sold") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <ProductSold />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "To Be Packed") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <ToBePacked />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "To Be Shipped") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <ToBeShipped />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "To Be Delivered") && (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <ToBeDelivered />
          </div>
        )}
      </div>

      {/* CHART ROW 1 */}
      <div className="row g-3 mb-4 mt-2">
        {dashboardMenus.some((m) => m.menuText === "Vendors Bar Chart") && (
          <div className="col-12 col-md-6 col-lg-4">
            <VendorsBarChart />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "Average Cost Chart") && (
          <div className="col-12 col-md-6 col-lg-4">
            <AverageCostChart />
          </div>
        )}

        {dashboardMenus.some(
          (m) => m.menuText === "Quality Purchase Chart"
        ) && (
            <div className="col-12 col-md-6 col-lg-4">
              <QualityPurchaseChart />
            </div>
          )}
      </div>

      {/* CHART ROW 2 */}
      <div className="row g-3 mb-4">
        {dashboardMenus.some(
          (m) => m.menuText === "Selling Plans Pie Chart"
        ) && (
            <div className="col-12 col-md-6 col-lg-4">
              <SellingPlansPieChart />
            </div>
          )}

        {dashboardMenus.some(
          (m) => m.menuText === "Purchase Analysis Chart"
        ) && (
            <div className="col-12 col-md-6 col-lg-8">
              <PurchaseAnalysisChart />
            </div>
          )}
      </div>

      {/* BOTTOM SECTION */}
      <div className="row g-3">
        {dashboardMenus.some((m) => m.menuText === "New Vendors") && (
          <div className="col-12 col-md-6 col-lg-4">
            <NewVendors />
          </div>
        )}

        {dashboardMenus.some((m) => m.menuText === "Sales Orders") && (
          <div className="col-12 col-md-6 col-lg-8">
            <SalesOrders />
          </div>
        )}
      </div>

      {/* ✅ Snackbar added from 2nd file */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={(event, reason) => {
          if (reason === "clickaway") return;
          setOpenSnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          top: "24px !important",
          right: "24px !important",
          zIndex: 99999,
        }}
      >
        <div className="custom-toast">
          <div className="custom-toast-icon-wrapper">
            <div className="custom-toast-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <div className="custom-toast-divider"></div>
          <div className="custom-toast-content">
            <strong>Login successful!</strong> Welcome{" "}
            <span className="toast-email">{loginUsername}</span>
          </div>
          <div className="custom-toast-progress"></div>
        </div>
      </Snackbar>
    </div>
  );
}